import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Loader;
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Loader } from "@crehana/ui";
import LazyLoad from "../../../Lazyload";
import Loadable from "../../../Loadable";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyBasicDataForm = function LazyBasicDataForm(props) {
  return /*#__PURE__*/_jsx(LazyLoad, {
    children: /*#__PURE__*/_jsx(Loadable, _objectSpread({
      module: function module() {
        return import(/* webpackChunkName: "basic-data-form" */"./BasicDataForm");
      },
      Loader: _Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {}))
    }, props))
  });
};
export default LazyBasicDataForm;